// @flow
import React, {Component} from 'react'
import {connect} from 'react-redux';
import {fetchCalenderItems} from '../../actions/calenders'
import {CalenderItemBox, StyledSection, StyledCard, StyledModalTitle} from './style'
import {Row, Col, Button} from 'antd';
import moment from 'moment'

class CalendarItems extends Component<{}> {

  state: State = {
    visible: false,
    item: '',
    currentDate: moment(new Date())
  }

  componentWillMount() {
    if (!this.props.calendarItems.length) {
      this.props.onFetchCalenderItems()
    }
  }

  getDifferentData = () => {
    let calendar = []
    const currDate = moment(this.state.currentDate.clone()).startOf('week').unix();
    const endDate = moment(this.state.currentDate.clone()).endOf('week').unix();
    this.props.calendarItems.forEach(item => {
        const date = moment(item.calendarenddate).unix();
        if (currDate <= date && date <= endDate) {
            calendar.push(item)
        }
    });
    if (calendar.length > 1) {
      calendar = calendar.sort((a, b) => {
        return moment(a.calendarenddate).unix() - moment(b.calendarenddate).unix();
      });
    }
    return calendar;
  }
  
  onNext = () => {
    this.setState({
      currentDate: this.state.currentDate.add('1', 'week'),
    })
  }
  
  onPrevious = () => {
    this.setState({
      currentDate: this.state.currentDate.add('-1', 'week'),
    })
  }

  render() {
    const { isFetching } = this.props
    const {currentDate} = this.state
    const calendar = this.getDifferentData()
    
    return (
      <div>
      <StyledSection>
        <StyledCard
          bordered={false}
          title={<div style={{width: '100%'}}>Upcoming OptionsEDU Events <div style={{float: 'right', display: 'inline-block'}}><b style={{marginRight: 20}}>{currentDate.clone().startOf('week').format('MMM Do YY')} to {currentDate.clone().endOf('week').format('MMM Do YY')}</b><Button style={{float: 'right'}} onClick={this.onNext}>Next Week</Button>
            <Button onClick={this.onPrevious} style={{float: 'right'}}>Previous Week</Button></div></div>}>
          <Row gutter={24}>
            {!isFetching &&
            calendar.map((item, i) => {
                const isFutureDate = moment().startOf('day').isBefore(moment(item.calendarenddate).startOf('day'));
                const title = (
                  <StyledModalTitle>
                    <div className="date dateView">
                      <span>{item.calendarenddate && moment(item.calendarenddate).format('ddd')}</span>
                      <b>{item.calendarenddate && moment(item.calendarenddate).format('D')}</b>
                      <span>{item.calendarenddate && moment(item.calendarenddate).format('MMM')}</span>
                    </div>
                  </StyledModalTitle>
                )

                return (<Col span={6} key={i}>
                      <CalenderItemBox hoverable onClick={() => this.props.showCalenderModal(item)} className={`${isFutureDate ? 'color-blue' : ''}`}>
                        <div>{title}</div>
                        <div>{item.title || ''}</div>
                      </CalenderItemBox>
                  </Col>
                )
              })
            }
            {
              calendar.length === 0 && <div>No Events for this week.</div>
            }
          </Row>
        </StyledCard>
      </StyledSection>
      </div>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  calendarItems: state.calenders.calendarItems || [],
  isFetching: state.calenders.isFetching,
})

const mapDispatchToProps = (dispatch: Function) => ({
  onFetchCalenderItems: () => {
    fetchCalenderItems(dispatch)
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarItems)



// WEBPACK FOOTER //
// ./src/components/view-calendar/calenderItems.js